module.exports = __webpack_public_path__ + "static/media/bez_temp_w_domu_off_3.efe95366.svg";